import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from "react-redux";
import DataTablesCreate from "./DataTablesCreate";
import { DISPATCH_ID } from "../libs/utils/Const";
import { ApiClient } from "../libs/apiClient";
const apiClient = ApiClient.getInstance();

const headers = [
    { title: 'Grupo' },
    { title: 'Nombre' }
];

class GroupCodeModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            grpCode: -1,
            grpName: '',
        }
    }

    UpdateStateField = async (key, value) => {
        await this.setState({
            [key]: value
        })
    }

    componentDidMount() {
        this.closeAction();
    }

    close = async () => {
        $('#groupCodeModal').modal('hide');
        await this.props.DisableModal();
    }

    closeAction = () => {
        const { cleanData } = this.props;
        // $('#groupCodeModal').on('hidden.bs.modal', function () {
        //     //console.log("cerrar groupCode");
        //     cleanData();
        // });
    };

    AddNewGrp = () => {
        this.setState({ grpName: '', grpCode: -1 })
        this.ShowManipulateGrpModal();
    }

    ShowManipulateGrpModal = () => {
        $('#groupCodeModal').modal('hide');
        $('#addNewGrpModal').modal('show');
    }

    CloseAddNewGrpModal = () => {
        const { OpenGroupCode } = this.props;
        $('#addNewGrpModal').modal('hide');
        $('#groupCodeModal').modal('show');
        OpenGroupCode();
    }

    EditPartnerGrp = async (index) => {
        const { data } = this.props
        const objectGrp = data[index];
        await this.setState({
            grpCode: objectGrp.GroupCode,
            grpName: objectGrp.GroupName,
        })
        this.ShowManipulateGrpModal();
        this.UpdateStateField('editMode', true)


    }

    CancelEditMode = () => {
        this.CloseAddNewGrpModal();
        this.UpdateStateField('editMode', false)
    }

    SendPartnerGrpCreate = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, OpenGroupCode } = this.props;
        const data = {
            Name: this.state.grpName
        }

        enableSpinner(true);
        const responseApi = await apiClient.partnerGrpCreate(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "warning", message: responseApi.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: "success", message: responseApi.message, timeOut: 5000 });
        // mandar a llamar de nuevo el get de DataTables
        $('#addNewGrpModal').modal('hide');
        $('#groupCodeModal').modal('hide');
        await this.props.DisableModal();
        OpenGroupCode();
    }

    SendPartnerGrpUpdate = async () => {
        const { enableSpinner, notificationReducer: { showAlert }, OpenGroupCode } = this.props;
        const data = {
            Code: this.state.grpCode,
            Name: this.state.grpName
        }

        enableSpinner(true);
        const responseApi = await apiClient.partnerGrpUpdate(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: "warning", message: responseApi.message, timeOut: 5000 });
            return;
        }

        showAlert({ type: "success", message: responseApi.message, timeOut: 5000 });
        // mandar a llamar de nuevo el get de DataTables
        $('#addNewGrpModal').modal('hide');
        $('#groupCodeModal').modal('hide');
        await this.props.DisableModal();
        OpenGroupCode();
    }

    render() {
        const { data, selectGroupCode, GroupCodesModal } = this.props;
        //console.log("data groupCode", data);

        if (data.length === 0) {
            return <div className="modal fade bd-example-modal-lg bgtransparent" role="dialog" id="groupCodeModal"></div>;
        }
        return (
            <div>
                {this.AddNewGrpModal()}
                {GroupCodesModal &&
                    <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="groupCodeModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg modal-open" role="document">
                            <div className="modal-content">

                                <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                    <h4 className="modal-title" id="modal-basic-title ">Grupo</h4>
                                    <button type="button" className="close" onClick={() => this.close()} aria-label="Close">
                                        <span className="text-white" aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <div className="modal-body">
                                    <div className="contanier">
                                        <div className="row justify-content-around">
                                            <div className="col-12">
                                                <div className="table-responsive">
                                                    <table className="table response" style={{ marginBottom: 0 }}>
                                                        <tbody>
                                                            <DataTablesCreate
                                                                data={data}
                                                                headers={headers}
                                                                view={"groupCodeModal"}
                                                                action={selectGroupCode}
                                                                EditPartnerGrp={this.EditPartnerGrp}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button type="button" className="btn botonCerrar text-white" onClick={this.AddNewGrp}>Agregar nuevo grupo</button>

                                    <button type="button" className="btn botonCerrar text-white" onClick={() => this.close()}>Cerrar</button>

                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }


    AddNewGrpModal = () => {
        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" role="dialog" id="addNewGrpModal" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{ backgroundColor: '#343a40', borderRadius: '0' }}>
                                <h4 className="modal-title" id="modal-basic-title ">{!this.editMode ? 'Agregar' : 'Editar'} grupo</h4>
                                <button type="button" className="close" onClick={this.CloseAddNewGrpModal} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="container">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className="row" style={{ paddingRight: 0 }} autoComplete="off">
                                                <div className="col-12 col-md-6">
                                                    <div className="input-group mb-3">
                                                        <div className="input-group-prepend">
                                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre grupo</span>
                                                        </div>
                                                        <input type="text" className="form-control"
                                                            style={{ backgroundColor: 'transparent', borderColor: '#ced4da', color: '#000' }}
                                                            onChange={(event) => this.UpdateStateField('grpName', event.target.value)}
                                                            value={this.state.grpName ?? ''}
                                                        />
                                                    </div>

                                                </div>
                                                <div className="col-12 col-md-6">


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                {this.state.editMode ?
                                    <>
                                        <button type="button" className="btn botonCerrar text-white" onClick={this.CancelEditMode}>Cancelar edición</button>
                                        <button type="button" className="btn btn-success" onClick={this.SendPartnerGrpUpdate}>Guardar edición</button>
                                    </>
                                    :
                                    <button type="button" className="btn botonCerrar text-white" onClick={() => this.SendPartnerGrpCreate()}>Guardar nuevo</button>
                                }



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}
const mapStateToProps = (store) => {
    return {
        notificationReducer: store.NotificationReducer,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        enableSpinner: (value) => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value }),
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(GroupCodeModal);
// export default GroupCodeModal;